import { createFileRoute, redirect } from "@tanstack/react-router";
import { CreateOrgPage } from "@/features/auth/create-org";
import { ensureMe } from "@/hooks/data";
import { isApiError } from "@/lib/api/errors";
import { adoptSession } from "@/lib/auth";

/**
 * A signed-in user with no organization creates one here (never a broken onboarding). Members of an org go home,
 * unless they came from the org switcher's "Create organization" (`?another=1`, ALP-84).
 */
export const Route = createFileRoute("/create-org")({
  validateSearch: (s: Record<string, unknown>): { another?: boolean } => (s.another === true || s.another === "1" || s.another === 1 ? { another: true } : {}),
  beforeLoad: async ({ context, search }) => {
    try {
      const me = await ensureMe(context.queryClient);
      if (adoptSession(me) && !search.another) throw redirect({ to: "/home" });
    } catch (e) {
      if (isApiError(e) && e.isUnauthorized) throw redirect({ to: "/login", search: { redirect: "/create-org" } });
      throw e;
    }
  },
  head: () => ({ meta: [{ title: "Create your organization · Malfak" }] }),
  component: CreateOrgPage,
});
